<div class="content">
  <div class="container-fluid">
    <div class="page-title clearfix">
      <h1 class="float-left">
        <a href="javascript:void(0);" class="back" (click)="goBack()">
          <i class="fa fa-arrow-left" aria-hidden="true"></i>
        </a>
        {{'Report Detail' | translate}}
      </h1>
    </div>
    <div class="page-filter clearfix multiple-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title" *ngIf="isMsp">
            <div class="filter-content">
              <p-select [options]="regionOption" [(ngModel)]="selectRegion" (onChange)="dispatchFilter()"></p-select>
            </div>
          </div>
          <!-- <div class="filter-list name_title">
            <div class="filter-content">
              <p-dropdown [options]="reportTypeOption" [(ngModel)]="reportType" (onChange)="dispatchFilter()"></p-dropdown>
            </div>
          </div> -->
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-select [options]="reportCategoryOption" [(ngModel)]="reportCategory" (onChange)="dispatchFilter('selectReportCategory')">
                <ng-template let-item pTemplate="selectedItem">
                  <span>{{ item.label | translate }}</span>
                </ng-template>

                <ng-template let-option pTemplate="item">
                  <span>{{ option.label | translate }}</span>
                </ng-template>
              </p-select>
            </div>
          </div>
          <div class="filter-list name_title" *ngIf="reportCategory === 0">
            <div class="filter-content">
              <p-select [options]="reportLoadTypeOption" [(ngModel)]="reportLoadType" (onChange)="reportFilter()"></p-select>
            </div>
          </div>
          <div class="filter-list name_title">
            <div class="filter-content">
              <p-select *ngIf="reportCategory === null" [options]="reportSystemWellnessOption" [(ngModel)]="reportSystemWellness" (onChange)="reportFilter()"></p-select>
              <p-multiSelect *ngIf="reportCategory === 0" [options]="(reportLoadDistributionOption)" [(ngModel)]="reportLoadDistribution" placeholder="{{'Choose' | translate}}" (onChange)="reportFilter($event)" [filter]="false" [maxSelectedLabels]="4"></p-multiSelect>
              <!-- <p-multiSelect [options]="(deviceSubtypeOptions)" [(ngModel)]="DeviceSubType" placeholder="{{'Choose' | translate}}" (onChange)="dispatchFilter(0,selectedDevice,$event)" [filter]="false" [maxSelectedLabels]="4"></p-multiSelect> -->
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-filter clearfix multiple-filter">
      <div class="filter-flex">
        <div class="filter">
          <div class="filter-list name_title" *ngIf="reportCategory === null || reportCategory === 1">
            <div class="filter-content">
              <p-select [options]="eventRangeOptions" [(ngModel)]="selectedEventRange" (onChange)="dispatchFilter()" placeholder="{{'Range' | translate}}">
                <ng-template pTemplate="item" let-item>
                  {{item.label}}  {{rangeOptionsUnit | translate}}
                </ng-template>
                <ng-template pTemplate="selectedItem" let-item>
                  {{item.label}}  {{rangeOptionsUnit | translate}}
                </ng-template>
              </p-select>
            </div>
          </div>
          <div class="filter-list name_title" *ngIf="reportCategory === 0 || reportCategory === 2">
            <div class="filter-content" style="margin: 0">
              <div class="filter-content">
                <p-select [options]="rangeOptions" [(ngModel)]="selectedRange" (onChange)="dispatchFilter()" placeholder="{{'Range' | translate}}">
                  <ng-template pTemplate="item" let-item>
                    {{item.label}}  {{rangeOptionsUnit | translate}}
                  </ng-template>
                  <ng-template pTemplate="selectedItem" let-item>
                    {{item.label}}  {{rangeOptionsUnit | translate}}
                  </ng-template>
                </p-select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page-content">
      <p-table class="deviceTable pageAllOptions" [columns]="reporDetailLogs_cols" [value]="getReportDetailLogs()" [rows]="10" [paginator]="true" [rowsPerPageOptions]="[10,20,{showAll:'All'}]" [scrollable]="true">
        <ng-template pTemplate="header" let-columns>
          <tr>
            <th style="width: 80px" class="col-nowrap text-center" *ngIf="reportCategory === null">{{'Status' | translate}}</th>
            <th style="width: 170px" class="col-nowrap" *ngIf="reportCategory === null || reportCategory === 0 || reportCategory === 1">{{'Time' | translate}}</th>
            <th *ngFor="let col of columns" [pSortableColumn]="col.field" [ngStyle]="{'width.px':(col.width) }" [ngClass]="col.class">
              {{col.header | translate}}
              <p-sortIcon [field]="col.field"></p-sortIcon>
            </th>
            <th style="width: 120px" class="col-nowrap" *ngIf="reportCategory === 0">{{'Peak Load' | translate}}</th>
            <th style="width: 120px" class="col-nowrap" *ngIf="reportCategory === 0">{{'Avg Load' | translate}}</th>
            <th style="width: 420px" class="col-nowrap" *ngIf="reportCategory !== 2">{{'Description' | translate}}</th>
            <th style="width: 300px" class="col-wrap" *ngIf="reportCategory === 2">{{'Estimated Consumption' | translate}} ({{ 'Est. kWh' | translate }})<br>
              {{'(Last 7 Days /Prior 7 Days)' | translate}}</th>
            <th style="width: 300px" class="col-wrap" *ngIf="reportCategory === 2">{{'Estimated Carbon Footprint' | translate}} (kgCO<sub>2</sub>e)<br>
              {{'(Last 7 Days /Prior 7 Days)' | translate}}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-rowData let-columns="columns">
          <tr>
            <td style="width: 80px" class="col-nowrap text-center" *ngIf="reportCategory === null">
              <span class="center" *ngIf="!rowData.isHardwareFault">
                <i class="fa {{rowData.icon}} {{rowData.status}}" aria-hidden="true"></i>
              </span>
            </td>
            <td style="width: 170px" class="col-nowrap" *ngIf="reportCategory === null || reportCategory === 0 || reportCategory === 1">
              {{rowData.time}}
            </td>
            <td style="width: 200px" class="col-nowrap ellipsis" *ngIf="reportCategory !== 0 else loadRedirct">
              <a [routerLink]="rowData.routeLink">{{rowData.deviceName}}</a>
            </td>
            <ng-template #loadRedirct>
              <td style="width: 200px" class="col-nowrap ellipsis">
                <a (click)="onLoadDistributionNameClick(rowData)">{{rowData.deviceName}}</a>
              </td>
            </ng-template>
            <td style="width: 200px" class="col-nowrap ellipsis">{{rowData.model}}</td>
            <td style="width: 120px" class="col-nowrap">{{rowData.type}}</td>
            <td style="width: 120px" class="col-nowrap" *ngIf="reportCategory === 0">
              <a href="javascript:void(0);" (click)="showLoadDailog(rowData.dcode, rowData.time)">
                {{ (rowData.maxLoad !== null && rowData.maxLoad !== undefined && rowData.maxLoad !== '-' && rowData.maxLoad !== '') ? rowData.maxLoad + '%' : '-' }}
              </a>
            </td>

            <td style="width: 120px" class="col-nowrap" *ngIf="reportCategory === 0">
              <a href="javascript:void(0);" (click)="showLoadDailog(rowData.dcode, rowData.time)">
                {{ (rowData.avgLoad !== null && rowData.avgLoad !== undefined && rowData.avgLoad !== '-' && rowData.avgLoad !== '') ? rowData.avgLoad + '%' : '-' }}
              </a>
            </td>
            <td style="width: 420px" class="col-nowrap" *ngIf="reportCategory !== 2">{{rowData.desc}}</td>
            <td style="width: 300px" class="col-nowrap" *ngIf="reportCategory === 2">
              {{ rowData.consumption != null && rowData.consumption !== '-' ? rowData.consumption : '-' }} / 
              {{ rowData.lastConsumption != null && rowData.lastConsumption !== '-' ? rowData.lastConsumption : '-' }} 
            </td>
            <td style="width: 300px" class="col-nowrap" *ngIf="reportCategory === 2">
              {{ rowData.co2e != null && rowData.co2e !== '-' ? rowData.co2e : '-' }} / 
              {{ rowData.lastCo2e != null && rowData.lastCo2e !== '-' ? rowData.lastCo2e : '-' }} 
            </td>
          </tr>
        </ng-template>
        <ng-template pTemplate="emptymessage">
          <tr>
            <td [attr.colspan]="getVisibleColumnsCount()">
              <div translate class="ui-emptymessage">No Event found</div>
            </td>
          </tr>
        </ng-template>
      </p-table>
    </div>
  </div>
</div>


<p-dialog header="{{'Load Percentage' | translate}}" [(visible)]="loadDailog" [modal]="true" [style]="{'width': '600px'}" [responsive]="true" class="chartDialog" [baseZIndex]="10000">
  <div class="page-content-body">
    <p-chart type="line" [data]="loadChart" [options]='chartOption' [style]="{'height': '350px'}"></p-chart>
  </div>
</p-dialog>
